<div class="row">
  <div class="col-lg-3">
    <sb-card>
      <div card-body>
        <ul class="nav-tabs nav sidenav">
          <li class="nav-item" *ngPermissions="permissionService.Permission.player_hardware_show">
            <a class="nav-link" [sbRouterLinkActive]="'active'" [isLinkActive]="util.RoutingID.playerHardwareOverview"
               [sbRouterLink]="util.RoutingID.playerHardwareOverview">
              <span>
                <sb-icon class="mr-3" icon="eye"></sb-icon>
                {{ 'lang.globals.overview' | translate }}
              </span>
            </a>
          </li>
        </ul>
      </div>
    </sb-card>
  </div>
  <div class="col-lg-9">
    <router-outlet></router-outlet>
  </div>
</div>
